/**
* 用户管理 用户列表
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >管理</el-breadcrumb-item>
      <!-- :to="{ path: '/' }" -->
      <el-breadcrumb-item>公告设置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <div style="margin-right:2%;">
      <h1 style="color: red;">公告标题和内容有一个为空则不会生效！</h1>
        <!--float: right; <el-button style='margin: 10px 0;margin-right: 20px;' size="mini" type="primary"
            icon="document" @click="dataSelect">刷新</el-button> -->
        <!-- <el-button style='margin: 10px 0;' size="mini" type="primary"
            icon="document" @click="addNotice">新增</el-button>  -->
            <!-- <el-button style='margin: 10px 0;' size="mini" type="primary"
            icon="document"><el-upload class="avatar-uploader" v-model="img"
             action="https://admin.shengqianxiong.com.cn/tao/upload" :show-file-list="false"
             :on-success="handleAvatarSuccess">新增</el-upload></el-button> -->
            <!-- <img v-if="img" :src="img" class="avatar"
              style="border-radius: 6px;width: 148px;height: 148px;" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
    </div>

    <el-table style="width:100%" border v-loading="tableDataLoading" :data="tableData" row-key="id" @selection-change="handleSelectionChange">
        <el-table-column
        type="selection"
        width="55">
        </el-table-column>
			<!-- <el-table-column  prop="id" label="编号" width="80">
			</el-table-column> -->
			<el-table-column align="center" prop="title" label="标题">
			</el-table-column>
      <el-table-column align="center" prop="content" label="内容">
        <template slot-scope="scope">
          <div v-html="scope.row.content"></div>
        </template>
			</el-table-column>
			<!-- <el-table-column width="150px" prop="createTime"  label="创建时间">
			</el-table-column> -->
			
			<el-table-column align="center" label="操作" width="240px">
				<template slot-scope="scope">
					<el-button size="mini" type="primary"
						@click="updates(scope.$index, scope.row)">修改
					</el-button>
					<!-- <el-button size="mini" type="danger" 
						@click="deletes(scope.row.id)">删除
					</el-button> -->
				</template>
			</el-table-column>
		</el-table>

    <el-dialog title="公告增加" :visible.sync="dialogFormVisible" center>
      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">标题：</span>
        <el-input style="width:50%;" type="number" v-model="addForm.title" placeholder="输入标题"></el-input>
      </div>

      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">内容：</span>
        <el-input style="width:50%;" type="number" v-model="addForm.content" placeholder="输入内容"></el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="releasNoticeTo()">添 加</el-button>
      </div>
    </el-dialog>

    <el-dialog title="公告修改" :visible.sync="dialogFormVisible1" center>
      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">标题：</span>
        <el-input style="width:50%;" v-model="updateForm.title" placeholder="输入标题"></el-input>
      </div>

      <div style="margin-bottom: 10px;display: flex;align-items: center;">
        <span style="width: 200px;display: inline-block;text-align: right;">内容：</span>
        <quill-editor ref="myTextEditor" v-model="updateForm.content" :options="quillOption"
					style="padding-bottom: 50px;height: 300px;width: 72%;display: inline-table;margin-bottom: 60px;">
				</quill-editor>
        <!-- <el-input style="width:50%;" type="textarea" v-model="updateForm.content" placeholder="输入内容"></el-input> -->
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateFrom(updateForm)">保 存</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>

import { addAnnouncement , deleteAnnouncement , getAnnouncementList , updateAnnouncement } from '../../../api/manage/announcement.js'

import moment from 'moment';

import DOMPurify from 'dompurify';

import {
		quillEditor
	} from 'vue-quill-editor'
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	import quillConfig from '../quill-config.js'

export default {
  name: 'news',
		components: {
			quillEditor
		},
  data() {
    return {
        quillOption: quillConfig,
        multipleSelection: [],
        totalnum:0,
        page : 1 ,
        size : 10,
        tableDataLoading:false,
        dialogFormVisible:false,
        dialogFormVisible1:false,
        tableData:[],
        addForm:{
          title:'',
          content:'',
        },
        updateForm:{
          title:'',
          content:'',
        },

    }
  },
  components: {

  },

  created() {
    this.dataSelect()
    // this.getdata(1)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    safeHtml(dirty) {
      return DOMPurify.sanitize(dirty);
    },

    releasNoticeTo(){
        let post = addForm;
        addAnnouncement(post).then((res) => {
            this.dialogFormVisible = false
            this.$message({
                type: "success",
                message: res.msg,
                duration: 1500,
                onClose: () => {
                    this.dataSelect()
                }
            });
        })
    },

    updates(index,row){
        // console.log("row",row)
        this.dialogFormVisible1 = true;
        this.updateForm = JSON.parse(JSON.stringify(row));
    },

    updateFrom(data){
      let post = data
      updateAnnouncement(post).then((res) => {
        this.tableDataLoading = false
        if (res.code == 200) {
            this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        }
        this.$message({
            type: "info",
            message: res.msg,
        });
      })
    },

    deletes(id){
      let obj = {
          id:id,
      }
      this.$confirm(`确定删除此条信息?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAnnouncement(obj).then(res => {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        })
      }).catch(() => {})
    },

    dataSelect(){
      let post = {
        // page : (this.page - 1 ) * this.size,
        // size : this.size
      }
      this.tableDataLoading = true;
      getAnnouncementList(post).then((res) => {
        this.tableDataLoading = false
        if (res.code == 200) {
            // this.tableData = res.data.data;
            // res.data.data.forEach(item => {
            //   // console.log(item.createTime);
            //   item.createTime=moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')
            //   // 
            // });
            this.tableData = res.data.data
            // console.log('this.tableDatathis.tableData',this.tableData)
            this.totalnum = res.data.count;
            return;
        }
        this.$message({
            type: "info",
            message: res.msg,
        });
    })

    },

     // 添加分类弹框
    addNotice() {
        this.addForm = {
          title:'',
          content:'',
        },
        this.dialogFormVisible = true
    },

  }
}
</script>

<style scoped>
.userRole {
  width: 100%;

}
</style>


// WEBPACK FOOTER //
// src/views/manage/announcement/index.vue